import React from 'react';
import '../../styles/components/AsperaOverflowButton.scss';
import { OverflowMenu, OverflowMenuItem } from '../Carbon';
/**
 * React Component
 *
 * The AsperaOverflowButton component renders the button that works like an overflow
 *
 * @example
 * ```javascript
 * <AsperaOverflowButton />
 * ```
 */
export class AsperaOverflowButton extends React.Component {
    render() {
        const { className, kind, name, icon, id, items, flipped } = this.props;
        const itemsToRender = items.filter(item => !item.hidden);
        const button = class ComponentView extends React.Component {
            render() {
                return (React.createElement("div", { className: `cds--btn cds--btn--${kind || 'primary'}` },
                    name,
                    icon && React.createElement(icon, { className: 'cds--btn__icon' })));
            }
        };
        if (!itemsToRender.length) {
            return null;
        }
        return (React.createElement("div", { className: `aspera-overflow-button ${className ? className : ''}` },
            React.createElement(OverflowMenu, { renderIcon: button, className: "aspera-overflow-button--overflow", iconDescription: name, "aria-label": name, menuOptionsClass: "aspera-overflow-button--overflow-list", "data-auto": `aspera-overflow-button--${id}`, flipped: flipped || false }, itemsToRender.map((item, index) => {
                return (React.createElement(OverflowMenuItem, { key: index, disabled: item.disabled, "data-auto": `aspera-overflow-button-item-${item.id}`, onClick: () => {
                        item.onClick(item);
                    }, itemText: item.name }));
            }))));
    }
}
